module.exports = __webpack_public_path__ + "static/media/TWO.f6b09549.png";